/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";

import Loading from "../common/Loading";

const DepartmentList = ({
  departments,
  onRowClick,
  isMobile,
  loading,
  services
}) => {
  const columns = [
    {
      Header: "Description",
      accessor: "description",
      sortable: true
    },
    { Header: "Code", accessor: "code", sortable: true },
    {
      Header: "Call Center Code",
      accessor: "call_center_code",
      sortable: true
    },
    {
      Header: "Default Service",
      accessor: "default_service.description",
      sortable: true
    },
    {
      Header: "Default Task",
      accessor: "defaultTaskDescription",
      sortable: true
    }
  ];

  const props = {
    getTdProps: (state, rowInfo, column) => {
      if (!column.expander) {
        return {
          onClick: () => column.id !== "_id" && onRowClick(rowInfo)
        };
      }
      return {};
    }
  };

  const data = departments.map((department) => {
    let defaultTaskDescription = "";
    const defaultService = services?.find(
      (service) =>
        service?._id ===
        (department.default_service?._id || department.default_service)
    );

    if (defaultService && defaultService.tasks?.length > 0) {
      const defaultTask = defaultService.tasks.find(
        (serviceTask) =>
          serviceTask?._id ===
          (department.default_task?._id || department.default_task)
      );
      if (defaultTask) {
        defaultTaskDescription = defaultTask.task?.description || "";
      }
    }

    return { ...department, defaultTaskDescription };
  });

  if (loading) {
    return (
      <div className="flex -center -full">
        <Loading active />
      </div>
    );
  }

  return (
    <ReactTable
      {...props}
      className="-highlight"
      data={data}
      loading={loading}
      LoadingComponent={() => <Loading active={loading} />}
      columns={columns}
      showPageSizeOptions={!isMobile}
      defaultPageSize={10}
      defaultSorted={[
        {
          id: "description",
          asc: true
        }
      ]}
    />
  );
};

DepartmentList.propTypes = {
  departments: PropTypes.array,
  onRowClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  loading: PropTypes.bool,
  services: PropTypes.array
};

export default DepartmentList;
